module.exports = __webpack_public_path__ + "static/media/wave.f977e0a1.svg";